import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';

export const updateSsoMetadata = ({ id, settings }) => (dispatch) => (
  dispatch(actions.updateSsoMetadata({ id, payload: settings }))
    .then(() => {
      dispatch(notificationActions.notifySuccess('Metadata has been updated!'));
    })
    .catch((error) => {
      dispatch(notificationActions.notifyError(error.response.data.error));
    })
);

export const deleteSsoMetadata = ({ id }) => (dispatch) => (
  dispatch(actions.deleteSsoMetadata({ id }))
    .then(() => {
      dispatch(notificationActions.notifySuccess('Metadata file has been removed'));
    })
    .catch((error) => {
      dispatch(notificationActions.notifyError('There was a problem with metadata file removal'));
      throw error;
    })
);

// All operations below belong to Global SSO managed via sso-service.
export const updateConfig = ({ orgUuid, data }) => (dispatch) => (
  dispatch(actions.updateConfig({ orgUuid, payload: data }))
    .catch((error) => {
      const errorMessage = (error?.response?.data) ? error.response.data.message : error.message;
      dispatch(notificationActions.notifyError(errorMessage));
    })
);

export const updateConfigWithNotify = ({
  orgUuid,
  data,
  message = 'Configuration successfully updated',
  header = undefined,
}) => (dispatch) => (
  dispatch(actions.updateConfig({ orgUuid, payload: data }))
    .then(() => {
      dispatch(notificationActions.notifySuccess(
        message,
        header,
        false,
        undefined,
        true,
      ));
    })
    .catch((error) => {
      const errorMessage = (error?.response?.data) ? error.response.data.message : error.message;
      dispatch(notificationActions.notifyError(errorMessage));
    })
);

export const deleteConfig = ({ orgUuid }) => (dispatch) => (
  dispatch(actions.deleteConfig({ orgUuid }))
    .then(() => {
      dispatch(notificationActions.notifySuccess(
        'Metadata file has been deleted from your SSO configuration',
        'File successfully deleted',
        false,
        undefined,
        true,
      ));
    })
    .catch((error) => {
      const errorMessage = (error?.response?.data) ? error.response.data.message : error.message;
      dispatch(notificationActions.notifyError(errorMessage));
    })
);
